module.exports = __webpack_public_path__ + "img/porta-logo.aee359b6.png";